<template>
  <v-dialog :value="true" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <span class="title-1">
          {{ isEdit ? "Editar acesso" : "Novo acesso" }} — Vivo Gestão
        </span>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-4">
        <v-form ref="validForm">
          <v-text-field
            v-model="form.description"
            label="Descrição"
            outlined
            dense
            prepend-inner-icon="mdi-text-short"
            :rules="[v => !!v || 'O campo é obrigatório']"
          />
          <v-text-field
            v-model="form.username"
            label="Usuário"
            outlined
            dense
            prepend-inner-icon="mdi-account-outline"
            :rules="[v => !!v || 'O campo é obrigatório']"
          />
          <v-text-field
            v-model="form.password"
            label="Senha"
            outlined
            dense
            prepend-inner-icon="mdi-lock"
            :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
            :type="passwordShow ? 'text' : 'password'"
            :rules="passwordRules"
            @click:append="passwordShow = !passwordShow"
          />
          <v-autocomplete
            v-model="form.accounts"
            :items="filteredAccountOptions"
            item-text="label"
            item-value="cod_conta"
            label="Contas"
            outlined
            dense
            multiple
            chips
            small-chips
            deletable-chips
            prepend-inner-icon="mdi-list-box"
            :loading="loadingAccounts"
            :filter="accountAutocompleteFilter"
            :rules="[v => (v && v.length > 0) || 'Selecione ao menos uma conta']"
          >
            <template v-slot:prepend-item>
              <div class="px-3 pt-2" @mousedown.prevent @click.stop>
                <v-text-field
                  v-model="accountSearch"
                  dense
                  hide-details
                  outlined
                  clearable
                  label="Pesquisar"
                  prepend-inner-icon="mdi-magnify"
                />
              </div>
              <v-list-item
                :disabled="!filteredAccountOptions.length"
                @mousedown.prevent
                @click.stop="selectAllFilteredAccounts"
              >
                <v-list-item-title>Selecionar todos</v-list-item-title>
              </v-list-item>
              <v-list-item
                :disabled="!form.accounts.length"
                @mousedown.prevent
                @click.stop="clearAllAccounts"
              >
                <v-list-item-title>Limpar</v-list-item-title>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-autocomplete>
          <v-switch
            v-model="form.active"
            inset
            :label="form.active ? 'Ativo' : 'Inativo'"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">Cancelar</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    selectedItem: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loadingAccounts: true,
      saving: false,
      passwordShow: false,
      accountSearch: "",
      accountOptions: [],
      form: {
        description: "",
        username: "",
        password: "",
        accounts: [],
        active: true,
      },
    };
  },
  computed: {
    isEdit() {
      return Boolean(this.selectedItem && this.selectedItem.id);
    },
    passwordRules() {
      if (this.isEdit) {
        return [];
      }

      return [v => !!v || "O campo é obrigatório"];
    },
    filteredAccountOptions() {
      const q = (this.accountSearch || "").trim().toLowerCase();

      if (!q) {
        return this.accountOptions;
      }

      return this.accountOptions.filter(opt =>
        opt.label.toLowerCase().includes(q) ||
        opt.cod_conta.toLowerCase().includes(q)
      );
    },
  },
  async mounted() {
    await this.loadAccounts();

    if (this.selectedItem) {
      this.form = {
        id: this.selectedItem.id,
        description: this.selectedItem.description,
        username: this.selectedItem.username,
        password: "",
        accounts: (this.selectedItem.accounts || []).map(code => String(code)),
        active: Boolean(this.selectedItem.active),
      };
    }
  },
  methods: {
    ...mapActions("account", ["loadAccount"]),
    ...mapActions("configurationIntegration", [
      "saveVivoGestaoAccess",
      "updateVivoGestaoAccess",
    ]),
    async loadAccounts() {
      this.loadingAccounts = true;
      try {
        await this.loadAccount();
        const accounts = this.$store.state.account.accounts || [];
        this.accountOptions = accounts.map(account => ({
          cod_conta: String(account.cod_conta),
          label: `${account.cod_conta} — ${account.descricao || ""}`,
        }));
      } catch (error) {
        this.$swal("Oops...", error.message, "error");
      }
      this.loadingAccounts = false;
    },
    accountAutocompleteFilter() {
      return true;
    },
    selectAllFilteredAccounts() {
      const codes = this.filteredAccountOptions.map(option => option.cod_conta);
      this.form.accounts = [...new Set([...this.form.accounts, ...codes])];
    },
    clearAllAccounts() {
      this.form.accounts = [];
    },
    closeDialog() {
      this.$emit("close");
    },
    async save() {
      if (!this.$refs.validForm.validate()) {
        return;
      }

      this.saving = true;
      try {
        if (this.isEdit) {
          await this.updateVivoGestaoAccess({ ...this.form });
          this.$swal("Acesso atualizado com sucesso", "", "success");
        } else {
          await this.saveVivoGestaoAccess({ ...this.form });
          this.$swal("Acesso cadastrado com sucesso", "", "success");
        }
        this.$emit("saved");
      } catch (error) {
        this.$swal("Oops...", error.message, "error");
      }
      this.saving = false;
    },
  },
};
</script>
